module.exports = __webpack_public_path__ + "static/media/pianohowto1.9794017c.png";